export default __webpack_public_path__ + "static/media/SportELS_Frente.3c4d5214.webp";